<div id="nextprev_noticias" class="nextprev_noticias row-2-columns">
  <ng-container *ngFor="let noticia of nextprev; trackBy: trackByNoticia; let i = index">
    <div [ngClass]="{ prev: i === 0, next: i === 1 }" class="nextprev_noticia">
      <a [routerLink]="['/noticias', noticia?.idVideo, noticia?.tituloSeo | kebabCase]" class="">
        <ng-container *ngIf="i === 0">
          <h4 class="nextprev">Noticia anterior</h4>
        </ng-container>
        <ng-container *ngIf="i === 1">
          <h4 class="nextprev">Noticia siguiente</h4>
        </ng-container>
        <div class="nextprev-container-noticia">
          <div class="image-container">
            <app-skeleton-image [size]="125" [created]="noticia?.fechaCreacion" [customClass]="'img-nextprev'" [src]="noticia.urlGenerica" [lazy]="true" width="100%" height="100%"></app-skeleton-image>
            <div class="icon-overlay">
              <ng-container *ngIf="i === 1">
                <app-icon-arrow-forward></app-icon-arrow-forward>
              </ng-container>
              <ng-container *ngIf="i === 0">
                <app-icon-arrow-back></app-icon-arrow-back>
              </ng-container>
            </div>
          </div>
          <div class="text-nextprev-container">
            <h4 class="text">{{ noticia.tituloVideo }}</h4>
          </div>
        </div>
      </a>
    </div>
  </ng-container>
</div>
